import React from "react"
import {
  UserSelector, LocationSelector, AccountSelector, ProviderSelector,
  BillingAccountSelector, CredentialSelector,
  QueryForm
} from "./index"
import {connect} from "react-redux"
import {withCommands} from "./index"
import * as at from "../actionTypes"
import * as jl from "../JobLevels"


const setQueryField = (fieldName, multi = true) => connect(
  function mapStateToProps(state, props) {

    return {
      ...props,
      selected: (state.manageTool.queryDisplay || {})[fieldName]
    }
  }, function mapDispatchToProps(dispatch, props) {

    return {
      ...props,
      onSelected(opts) {
        dispatch({
          type: at.SET_QUERY,
          query: {
            [fieldName]: multi ? opts && opts.map(x => x.value) : opts.value
          },
          queryDisplay: {
            [fieldName]: opts
          }

        })
      }
    }
  })



const SetUsers = setQueryField('userIds')(UserSelector);
const SetLocations = setQueryField('locationIds')(LocationSelector);
const SetAccounts = setQueryField('accountIds')(AccountSelector);
const SetBillingAccounts = setQueryField('billingAccountIds')(BillingAccountSelector);
const SetCredentials = setQueryField('credentialIds')(CredentialSelector);
const SetProvider = setQueryField('provider', false)(ProviderSelector);


const withQueryCommands = component => withCommands(connect(function mapStateToProps(state, props) {
  return {
    query: state.manageTool.query,
    ...props
  }
})(component))

const LocationQuery = withQueryCommands(({}) => {
  return <QueryForm>
    <h4>Find Locations</h4>
    <SetLocations/>
    <SetUsers/>
    <SetAccounts/>
    <SetBillingAccounts/>
  </QueryForm>
});

const LocationAndProviderQuery = withQueryCommands(({}) => {

  return <QueryForm>
    <h4>Find Locations And Provider</h4>
    <SetProvider/>
    <hr />
    <SetLocations/>
    <SetUsers/>
    <SetAccounts/>
    <SetBillingAccounts/>
  </QueryForm>
});

const UserQuery = withQueryCommands(({}) => {
  return <QueryForm>
    <h4>Find Users</h4>
    <SetAccounts/>
    <SetUsers/>
    <SetBillingAccounts/>
  </QueryForm>
})

const AccountQuery = withQueryCommands(({}) => {
  return <QueryForm>
    <h4>Find Accounts</h4>
    <SetAccounts/>
    <SetBillingAccounts/>
  </QueryForm>
});

const BillingAccountQuery = withQueryCommands(({}) => {
  return <QueryForm>
    <h4>Find Billing Accounts</h4>
    <SetBillingAccounts/>
  </QueryForm>
})

const CredentialQuery = withQueryCommands(({}) => {
  return <QueryForm>
    <h4>Find Credentials</h4>
    <SetCredentials/>
    <SetAccounts/>
    <SetBillingAccounts/>
  </QueryForm>
})

const RemotePageQuery = withQueryCommands(({}) => {
  return <QueryForm>
    <h4>Find Page</h4>
    <SetProvider/>
    <SetCredentials/>
    <SetAccounts/>
    <SetBillingAccounts/>
    <SetLocations />
  </QueryForm>
})


const queryComponentsByJobLevel = {
  [jl.LocationKey]: <LocationQuery/>,
  [jl.LocationProviderKey]: <LocationAndProviderQuery/>,
  [jl.UserKey]: <UserQuery/>,
  [jl.AccountKey]: <AccountQuery/>,
  [jl.BillingAccountKey]: <BillingAccountQuery/>,
  [jl.CredentialKey]: <CredentialQuery/>,
  [jl.RemotePageKey]: <RemotePageQuery/>
}


export const JobQueries = withCommands(connect(function mapStateToProps(state, ownProps) {
  return {
    ...state.manageTool,
    ...ownProps
  }
})(({
      selectedJobType,
      jobTypesById
    }) => {
  const jobType = jobTypesById[selectedJobType]
  return <div>{
    !jobType ? undefined : queryComponentsByJobLevel[jobType.jobLevel]
  }</div>
}));


